/**
 * VitaTein Glow Edition — promo landing page
 * 1. Sticky buy bar slides in once the hero offer scrolls out of view.
 * 2. Buy buttons show a loading state while the add-to-cart form submits.
 * No dependencies. The page works without JS (plain form POST to /cart/add).
 */
(() => {
  const sticky = document.getElementById('vt-sticky');
  const hero = document.getElementById('offer');

  if (sticky && hero && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => sticky.classList.toggle('vt-sticky--on', !entries[0].isIntersecting),
      { rootMargin: '-120px 0px 0px 0px' }
    );
    observer.observe(hero);
  }

  const form = document.getElementById('vt-buy-form');
  if (!form) return;

  const buttons = () => document.querySelectorAll('button[form="vt-buy-form"]');

  form.addEventListener('submit', () => {
    for (const button of buttons()) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }
  });

  // Coming back via the browser's back button (bfcache): re-enable the buttons.
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    for (const button of buttons()) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();

/* V2: customer video cards — swap the cover for the real video on click. */
(() => {
  const cards = document.querySelectorAll('.vt-vcard[data-src]');
  if (!cards.length) return;
  const stopOthers = (current) => {
    for (const v of document.querySelectorAll('.vt-vcard video')) if (v !== current) v.pause();
  };
  for (const card of cards) {
    card.addEventListener('click', () => {
      const src = card.dataset.src;
      if (!src) return;
      const video = document.createElement('video');
      video.src = src;
      const img = card.querySelector('img');
      if (img) video.poster = img.currentSrc || img.src;
      video.controls = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.preload = 'auto';
      video.addEventListener('play', () => stopOthers(video));
      const box = document.createElement('div');
      box.className = 'vt-vcard is-playing';
      box.appendChild(video);
      card.replaceWith(box);
      video.play().catch(() => {});
    });
  }
})();

/* V2: bag quantity steppers. Buy links point to cart permalinks (/cart/ID:QTY),
   which set the exact quantity instead of adding to whatever is already in the cart. */
(() => {
  const steppers = document.querySelectorAll('[data-vt-qty]');
  const links = document.querySelectorAll('a[data-vt-buy][data-href]');
  if (!links.length) return;
  const MAX = 6;
  let qty = 1;
  const money = (cents) => '$' + (cents / 100).toFixed(2);
  const render = () => {
    for (const s of steppers) {
      s.querySelector('output').textContent = qty;
      s.querySelector('[data-step="-1"]').disabled = qty <= 1;
      s.querySelector('[data-step="1"]').disabled = qty >= MAX;
    }
    for (const a of links) {
      a.href = a.dataset.href.replace('__QTY__', String(qty));
      if (a.dataset.unit && a.dataset.cta) {
        const total = money(Number(a.dataset.unit) * qty);
        a.textContent = a.dataset.cta + ' — ' + (qty > 1 ? qty + ' bags, ' : '') + total;
      }
    }
  };
  for (const s of steppers) {
    s.addEventListener('click', (e) => {
      const b = e.target.closest('[data-step]');
      if (!b) return;
      qty = Math.min(MAX, Math.max(1, qty + Number(b.dataset.step)));
      render();
    });
  }
  render();
})();

/* View nutrition label dialog */
(function(){
  var dlg=document.getElementById('vt-nl'); if(!dlg) return;
  var root=document.documentElement;
  function open(e){ if(e) e.preventDefault(); if(typeof dlg.showModal==='function'){ dlg.showModal(); } else { dlg.setAttribute('open',''); } root.style.overflow='hidden'; }
  function close(){ if(typeof dlg.close==='function'){ dlg.close(); } else { dlg.removeAttribute('open'); root.style.overflow=''; } }
  document.querySelectorAll('[data-vt-nl-open]').forEach(function(b){ b.addEventListener('click', open); });
  dlg.querySelectorAll('[data-vt-nl-close]').forEach(function(b){ b.addEventListener('click', close); });
  dlg.addEventListener('click', function(e){ if(e.target===dlg) close(); });
  dlg.addEventListener('close', function(){ root.style.overflow=''; });
})();
